import React, { useState, useEffect } from "react";

function ClientReview() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviews = [
    {
      name: "- samhitha tarra",
      location: "New York, NY",
      contentHeading: "Thoughtful and Seamless ",
      content:
        "Can’t say enough good things about Sridhar, as a first time home buyer he was very helpful in getting me the best rate and making the process very seamless from start to finish. Would highly recommend him to anyone looking for a lender to guide them through the process and get the job done in a timely manner!",
    },
    {
      name: "- imran ",
      location: "Raleigh, NC",
      contentHeading:
        "Seamless, Transparent, and Hassle-Free Experience with Sridhar! ",
      content:
        "I had a fantastic experience working with Sridhar. The entire process was transparent from start to finish, with quick responses to any questions I had. Once he took over the lending process, everything was hassle-free, making it smooth and stress-free. I highly recommend Sridhar to anyone looking for a seamless loan lending experience!",
    },
    {
      name: "- Mahi ",
      location: "Sterling, VA",
      contentHeading: "Exceptional Loan Officer Service ",
      content:
        "I recently worked with Sridhar at Prime Home Loans for my home purchase in Aldie, Chantilly, Virginia, and I couldn’t be more satisfied with his service. Sridhar provided clear, timely communication and expert guidance throughout the entire loan process. His professionalism and attention to detail made the process smooth and stress-free. Sridhar went above and beyond to ensure I received the best possible loan terms and was always available to answer questions. I highly recommend his services to anyone in need of a reliable and knowledgeable loan officer. Thank you, Sridhar, for your outstanding support!",
    },

    {
      name: "- vyshnavithotakura",
      location: "Montvale, NJ",
      contentHeading: "Happy with overall process ",
      content:
        "I recently had the pleasure of working with Ramesh to secure a mortgage for my home in New Jersey, and I couldn’t be happier with the experience! From start to finish, Ramesh made the process incredibly easy and smooth. He guided me through every step of the mortgage process, ensuring that I was always informed and confident in my decisions. His communication was excellent; I never felt left in the dark about what was happening. Ramesh’s honesty and transparency truly set him apart, making it clear that he had my best interests at heart.Thanks to Ramesh’s expertise and support, I was able to secure the mortgage I needed without any hassle. I highly recommend Ramesh to anyone looking for a reliable and knowledgeable mortgage specialist. His dedication to his clients is commendable, and I am very grateful for all his help!",
    },
    {
      name: "- pradeep paritala",
      location: "Fuquay Varina, NC",
      contentHeading:
        "Outstanding Support and Expertise for Home Loans and Refinancing! ",
      content:
        "I had an exceptional experience working with Ramesh as my home loan originator. He is incredibly honest, prompt, and transparent in every aspect of the process. Ramesh went above and beyond to ensure I got the best possible interest rate for both my first home purchase and a subsequent refinancing. As a first-time homebuyer, I had many questions, and Ramesh took the time to explain everything in great detail, making the entire process smooth and stress-free. Whether you're buying your first home or refinancing, Ramesh's expertise and commitment make him an excellent choice. I’m truly grateful for his guidance and support throughout my journey.",
    },
    {
      name: "- Kappi V",
      location: "Apex, NC",
      contentHeading:
        "Exceptional Service: Honest, Prompt, and Best Deal Offered! ",
      content:
        "I had the pleasure of working with Jegadheesan during my mortgage process, and I cannot recommend him highly enough. He is honest, prompt, transparent, always demonstrating complete professionalism—even when I was exploring options with others to determine what was best for me. What stood out most was his approach—he didn’t try to time the market or push unnecessary products, but instead focused on understanding my needs and offering the best possible deal. His professionalism and dedication ensured I got a competitive rate, and his communication throughout the process was impeccable. If you’re looking for someone trustworthy and efficient to guide you through the mortgage process, look no further...Jegadheesan is the person to call.",
    },
    {
      name: "- Ashutosh",
      location: "Cary, NC",
      contentHeading: "Very prompt and knowledgable! ",
      content:
        "Thank you, Jegadheesan, for handling my mortgage work very professionally. Your timely followup and assistance made the whole process effortless. You are the best! and I'd definitely recommend my friends and colleagues.",
    },

    {
      name: "- SathyKalyan",
      location: "Holly Springs, NC",
      contentHeading:
        "Exceptional Support and Expertise for First-Time Homebuyers ",
      content:
        "As a first-time homebuyer, I couldn’t have asked for a better experience than working with Visvesh Balasubramanian. Visvesh guided me through the entire mortgage process with patience, clarity, and professionalism. He took the time to explain every step, ensuring I fully understood my options and felt confident in my decisions. His responsiveness and attention to detail were outstanding, making what could have been an overwhelming process feel smooth and manageable. I’m truly grateful for his expertise and support in helping me achieve this milestone. I highly recommend Visvesh Balasubramanian to anyone, especially first-time buyers, looking for a knowledgeable and trustworthy mortgage professional.",
    },
    {
      name: "- Karthik ",
      location: "Apex, NC",
      contentHeading: "Excellent Job on my refinancing for 2nd time ",
      content:
        "I recently worked with Visvesh on refinancing my mortgage, and I couldn’t be happier with the service I received. From the very beginning, he was transparent and straightforward about the entire process, which made me feel confident and at ease. He explained all the details, walked me through the options, and ensured I understood each step before making any decisions. The communication was excellent, and Visvesh was always available to answer my questions promptly. I truly appreciated his honesty and professionalism, which made the whole experience stress-free. If you’re looking for a mortgage broker who is reliable, transparent, and dedicated to getting the best results for you, I highly recommend Visvesh. Feel free to personalize the details further to match your experience!",
    },
    {
      name: "- Venkat Cherukuru",
      location: "Sterling, VA",
      contentHeading:
        "Exceptional Service and Smooth Mortgage Refinance Experience with Visvesh ",
      content:
        "I recently completed a mortgage refinance, and I couldn’t be more pleased with the service I received from Visvesh. He was incredibly professional, knowledgeable, and made the entire process seamless. Visvesh was always available to answer my questions, provided clear explanations, and ensured everything was handled smoothly from start to finish. His attention to detail and commitment to making this experience stress-free truly set him apart. I highly recommend Visvesh to anyone looking for a skilled and dedicated loan officer.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [reviews.length]);

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % reviews.length);
  };

  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + reviews.length) % reviews.length);
  };

  return (
    <div className="OurSatisfiedBoxParent">
      <div className="OurSatisfiedBox">
        {reviews.map((review, index) => (
          <div
            className={`OurSatisfiedContentBox ${
              index === currentIndex ? "active" : "inactive"
            }`}
            key={index}
          >
            <span className="OurSatisfiedStars">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </span>
            <span className="OurSatisfiedContent">
              <span className="OurSatisfiedName">{review.contentHeading}</span>
              {review.content}
            </span>
            <span className="OurSatisfiedNameLocation">
              <span className="OurSatisfiedName">{review.name}</span>
              <span className="OurSatisfiedLocation">{review.location}</span>
            </span>
          </div>
        ))}
      </div>
      <span className="OurSatisfiedArrows">
        <i
          className="ri-arrow-left-wide-fill OurSatisfiedLeftArrow"
          onClick={handlePrev}
        ></i>
        <i
          className="ri-arrow-right-wide-fill OurSatisfiedRightArrow"
          onClick={handleNext}
        ></i>
      </span>
    </div>
  );
}

export default ClientReview;
